import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'color': [] }],
    ['link'],
    ['clean']
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline',
  'list', 'bullet', 'color', 'link'
];

export function RichTextEditor({ value, onChange, placeholder = 'Escribe aquí...' }) {
  const mods = useMemo(() => modules, []);
  return (
    <div className="rich-editor-wrapper">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={mods}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
}

export function RichTextDisplay({ content }) {
  if (!content || content === '<p><br></p>') return null;
  return (
    <div 
      className="rich-text-display"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

export function stripHtml(html) {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
